import { Component, OnInit } from '@angular/core';
import { AppState } from "../../../reducers";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";

@Component({
	selector: 'counter-done-reports',
	template: require("./counter-done-reports.html"),
	styles: [require("./counter-done-reports.scss")]
})
export class CounterDoneReportsComponent implements OnInit {

	nrDoneJobs$: Observable<number>;

	constructor(
		private store: Store<AppState>
	) {
	}

	ngOnInit(): void {
		this.nrDoneJobs$ = this.store.select("reporting", "reportJobs")
			.map(jobs => jobs.filter(job => job.status === 'DONE').length)
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/download-status/counter-done-reports/counter-done-reports.component.ts